import React from "react";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import AssignmentIcon from '@mui/icons-material/Assignment';

const Manual = () => {
  const fileList = [
    {
      label: "คู่มือการฝึกงานสำหรับภาคฤดูร้อน",
      path: `${process.env.PUBLIC_URL}/assets/file/manual/ENGBUU-internMiniHandbook.pdf`,
    },
    {
      label: "ปฏิทินการฝึกงานปีการศึกษา ภาคฤดูร้อน 2566",
      path: `${process.env.PUBLIC_URL}/assets/file/manual/ENGBUU-interncalendar1.pdf`,
    },
  
    {
      label: "แบบแจ้งรายละเอียดการปฏิบัติงานและแผนที่ตั้งสถานประกอบการ",
      path: `${process.env.PUBLIC_URL}/assets/file/manual/ENG-Coop S004.pdf`,
    },

    {
      label:
        "แบบบันทึกการฝึกงาน (Logbook) และ รายงานความก้าวหน้า (Progress Report) แบบ pdf ",
      path: `${process.env.PUBLIC_URL}/assets/file/manual/logbook.pdf`,
    },

    {
      label:
        "แบบบันทึกการฝึกงาน (Logbook) และ รายงานความก้าวหน้า (Progress Report)แบบ word ",
      path: `${process.env.PUBLIC_URL}/assets/file/manual/logbook.docx`,
    },

    {
      label: "ตัวอย่างแบบรรายงานฝึกงาน (Final Report) ",
      path: `${process.env.PUBLIC_URL}/assets/file/manual/Templete_Final Report ENGBUU-67.docx`,
    },

    {
      label: "ตัวอย่างใบลา",
      path: `${process.env.PUBLIC_URL}/assets/file/manual/ใบลา.doc`,
    },
    {
      label: "ตัวอย่างใบลา กรณี ประสบอุบัติเหตุ.doc",
      path: `${process.env.PUBLIC_URL}/assets/file/manual/ใบลา กรณี ประสบอุบัติเหตุ.doc`,
    },

    {
      label: "ประกาศการเบิกค่ารักษาพยาบาล กรณี เกิดอุบัติเหตุ",
      path: `${process.env.PUBLIC_URL}/assets/file/manual/1680512449.pdf`,
    },
  ];

  return (
    <div>
      <h3 style={{ color: 'blue' }}>เอกสารที่ใช้การฝึกงานภาคฤดูร้อน</h3>
      <ul>
        {fileList?.map((file, index) => {
          const isEven = index % 2 === 0;
          return (
            <List dense={true}>
              <ListItem disablePadding style={{ border: '1px solid black', borderRadius: '10px', backgroundColor: 'white' }}>
                <ListItemButton>
                  <ListItemIcon style={{ marginRight: '-16px' }}>
                    <AssignmentIcon />
                  </ListItemIcon>
                  <ListItemText>
                    <a href={file.path} target="_blank">
                      {file.label} </a>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            </List>
          );
        })}
      </ul>
    </div>
  );
};

export default Manual;
